<template>
    <CashflowTable></CashflowTable>
</template>

<script>
import CashflowTable from "@/components/cashflow/CashflowTable.vue";

export default {
    components: {
        CashflowTable
    },
    data: () => ({}),

    computed: {},

    watch: {},

    created() { },

    methods: {}
};
</script>